exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#hwLoginDivId .otherLoginWays {\n    width: 100%;\n    justify-content: space-around;\n}\n\n.privacyMsg{\n    margin-top: 70px;\n    margin-bottom: 0px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./public/hws/css/login_sdk.lazy.css
// module id = 238
// module chunks = 0